/* eslint-disable no-param-reassign */
/* eslint-disable no-multi-assign */
/* eslint-disable no-case-declarations */
import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCreditCard,
} from '@fortawesome/fontawesome-free-regular';
/* Material */
import {
  Input,
  IconButton,
  ButtonBase,
  InputAdornment,
} from '@material-ui/core';
import {
  AddCircle,
  KeyboardArrowLeft,
  KeyboardArrowRight,
} from '@material-ui/icons';
import { toast } from 'react-toastify';
/* Mask */
import DollarMask from '../../../../Mask/DollarMask';
/* Component */
import AmountSelect from './AmountSelect';
import SpeiIcon from '../../../../Icons/SpeiIcon';

const AmountPayable = ({
  title,
  charge,
  inputEl,
  paidOut,
  onSubmit,
  payIndex,
  isLoading,
  addPayment,
  totalToPay,
  setPayIndex,
  onBlurCharge,
  changePayable,
  newPaymentTypes,
}) => {
  const returnIcon = () => {
    const actualPayment = newPaymentTypes[payIndex];
    switch (actualPayment.id) {
      case ('Transferencia (SPEI)'):
        return (<SpeiIcon />);
      case ('Tarjeta de Credito'):
        return (<FontAwesomeIcon icon={faCreditCard} />);
      case ('Tarjeta de Debito'):
        return (<FontAwesomeIcon icon="credit-card" />);
      case ('Cheque'):
        return (<FontAwesomeIcon icon="money-check" />);
      default:
        return (<FontAwesomeIcon icon="money-bill-wave" />);
    }
  };

  return (
    <>
      <div className="w-100 checkoutPayableTitle">
        <p>{title}</p>
      </div>
      <div className="w-100 amount_payable">
        {/* <div className="w-100 d-flex align-items-center justify-content-center mb-2">
          <div className="payments_symbol">
            {returnIcon()}
          </div>
          <div className="paymentArrow paymentArrow_left">
            <ButtonBase
              onClick={() => {
                const newI = payIndex -= 1;
                setPayIndex(newI);
              }}
              disabled={payIndex === 0}
            >
              <KeyboardArrowLeft
                color={payIndex === 0 ? 'disabled' : 'inherit'}
              />
            </ButtonBase>
          </div>
          <AmountSelect
            payIndex={payIndex}
            setPayIndex={setPayIndex}
            newPaymentTypes={newPaymentTypes}
          />
          <div className="paymentArrow">
            <ButtonBase
              onClick={() => {
                const newI = payIndex += 1;
                setPayIndex(newI);
              }}
              disabled={payIndex === (newPaymentTypes.length - 1)}
            >
              <KeyboardArrowRight
                color={payIndex === (newPaymentTypes.length - 1) ? 'disabled' : 'inherit'}
              />
            </ButtonBase>
          </div>
        </div> */}
        <Input
          autoFocus
          autoComplete="off"
          id="payable_dollar"
          inputRef={inputEl}
          onBlur={onBlurCharge}
          onChange={changePayable}
          inputComponent={DollarMask}
          className="w-100 amount_payable_field"
          onKeyUp={(event) => {
            const { keyCode, target } = event;
            let newI = 0;
            switch (keyCode) {
              case 9:
                // @ts-ignore
                event.preventDefault();
                // @ts-ignore
                target.select();
                break;
              case 13:
                if (!isLoading) {
                  onSubmit();
                } else {
                  toast.warn('Espere un momento');
                }
                break;
              case 38:
                // @ts-ignore
                target.focus();
                if (payIndex > 0) {
                  newI = payIndex -= 1;
                  setPayIndex(newI);
                  event.preventDefault();
                }
                break;
              case 40:
                // @ts-ignore
                target.focus();
                if (payIndex < (newPaymentTypes.length - 1)) {
                  newI = payIndex += 1;
                  setPayIndex(newI);
                  event.preventDefault();
                }
                break;
              case 107:
                if (charge > 0) {
                  addPayment();
                } else {
                  addPayment(totalToPay);
                }
                break;
              default:
                break;
            }
            // @ts-ignore
            event.preventDefault();
          }}
          onFocus={(e) => {
            // @ts-ignore
            e.target.select();
            e.preventDefault();
          }}
          error={(charge + paidOut) <= 0}
          endAdornment={(
            <InputAdornment position="end">
              <IconButton
                color="primary"
                aria-label="addPart"
                onClick={() => addPayment()}
              >
                <AddCircle />
              </IconButton>
            </InputAdornment>
          )}
        />
      </div>
    </>
  );
};

AmountPayable.propTypes = {
  title: PropTypes.string,
  charge: PropTypes.number,
  isLoading: PropTypes.bool,
  payIndex: PropTypes.number,
  addPayment: PropTypes.func,
  totalToPay: PropTypes.number,
  onSubmit: PropTypes.func.isRequired,
  paidOut: PropTypes.number.isRequired,
  setPayIndex: PropTypes.func.isRequired,
  onBlurCharge: PropTypes.func.isRequired,
  changePayable: PropTypes.func.isRequired,
  inputEl: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.object }),
  ]).isRequired,
  newPaymentTypes: PropTypes.array.isRequired,
};

AmountPayable.defaultProps = {
  charge: 0,
  payIndex: 0,
  totalToPay: 0,
  isLoading: false,
  addPayment: () => {},
  title: 'Método de Pago',
};

export default AmountPayable;
